import styled from 'styled-components';

import { fontSizes, textColors } from 'ui/theme';

const DisplayLabel = styled.span`
  color: ${textColors.textDisabled};
  word-break: break-word;
  font-size: ${fontSizes.s14};
`;

export const NoDetails = () => (
  <div data-test="event-history-no-details">
    <DisplayLabel>No details to display</DisplayLabel>
  </div>
);
